<template>
  <v-layout row wrap>
    <vue-title :title="$t('competition.title')" />
    <v-flex xs12 md5>
      <v-layout column>
        <v-flex ma-2>
          <FCCCompetitionDetails />
        </v-flex>
        <v-flex ma-2>
          <FCCCompetitionApplicationCycles />
        </v-flex>
        <v-flex ma-2>
          <FCCCompetitionCategories />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md7>
      <v-layout column>
        <v-flex ma-2>
          <FCCCompetitionRaces />
        </v-flex>
        <v-flex ma-2>
          <FCCCompetitionPenalities />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
  } from 'vuetify/lib'
  import FCCCompetitionDetails from '../components/competition/FCCCompetitionDetails'
  import FCCCompetitionApplicationCycles from '../components/competition/FCCCompetitionApplicationCycles'
  import FCCCompetitionRaces from '../components/competition/FCCCompetitionRaces'
  import FCCCompetitionCategories from '../components/competition/FCCCompetitionCategories'
  import FCCCompetitionPenalities from '../components/competition/FCCCompetitionPenalities'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Competition',
    data: () => ({
      search: "",
      headers: [
        { text: 'competition', value: 'competition' },
        { text: 'title', value: 'title' },
        { text: 'type', value: 'type' },
        { text: 'category', value: 'category' }
      ],
      items: []
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      FCCCompetitionDetails,
      FCCCompetitionApplicationCycles,
      FCCCompetitionRaces,
      FCCCompetitionCategories,
      FCCCompetitionPenalities
    },
    mounted() {
      fccapi.competitionGet('races').then((r) => {
          this.items = r.data;
      })
    }
  }
</script>